import { paths } from "helpers/paths";
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/itemChangePoints";
import List from "./list";
import Show from "./show";

export default class ItemChangePoints extends Component {
    componentWillUnmount() {
        this.props.clearParams("item-change-points");
    }

    render() {
        const { match, location, history } = this.props;
        const back = () => history.push(match.path);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route
                        exact
                        path={match.path}
                        render={() => (
                            <List
                                {...this.props}
                                isTable
                                transition="full"
                                title="Список адресов перецепок"
                                source={source}
                                nofilter
                                back={() => history.push(paths.customPoints)}
                            />
                        )}
                    />
                    <Route
                        path={`${match.path}/:id`}
                        render={(rest) => <Show {...rest} title="Адрес перецепки" back={back} source={source} />}
                    />
                </Switch>
            </div>
        );
    }
}
